import React from "react";

import {
  ActionButton,
  BottomActionSheet,
  CancelButton,
  HeaderInfo,
  HeaderSubtitle,
  HeaderTitle,
  SheetCard,
  SheetHeader,
} from "../../../../../../components/BottomActionSheet";
import {
  DateFormat,
  formatCurrency,
  formatDate,
} from "../../../../../../utils";
import { AmountText } from "../styles";
import { getAmountDisplay, getPillLabel } from "../utils";
import { TransactionActionSheetProps } from "./types";

export const TransactionActionSheet: React.FC<TransactionActionSheetProps> = ({
  transaction,
  isOpen,
  onClose,
  onEdit,
  onDuplicate,
  onDelete,
}) => {
  if (!transaction) {
    return null;
  }

  const pillLabel = getPillLabel(transaction.transactionType);
  const { sign, variant } = getAmountDisplay(transaction);
  const title = transaction.categoryName ?? pillLabel;
  const subtitleParts = [
    transaction.subCategoryName,
    formatDate(transaction.transactionDate, DateFormat.DMY_SPACE),
  ].filter(Boolean);
  const subtitle = subtitleParts.join(" · ");

  const runAction = (action: () => void) => {
    action();
    onClose();
  };

  return (
    <BottomActionSheet
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="Transaction actions"
    >
      <SheetCard>
        <SheetHeader>
          <HeaderInfo>
            <HeaderTitle>{title}</HeaderTitle>
            {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
          </HeaderInfo>
          <AmountText $variant={variant}>
            {sign}
            {formatCurrency(transaction.amount)}
          </AmountText>
        </SheetHeader>
        <ActionButton
          type="button"
          onClick={() => runAction(() => onEdit(transaction))}
        >
          Edit
        </ActionButton>
        <ActionButton
          type="button"
          onClick={() => runAction(() => onDuplicate(transaction))}
        >
          Duplicate
        </ActionButton>
        <ActionButton
          type="button"
          $variant="destructive"
          onClick={() => runAction(() => onDelete(transaction))}
        >
          Delete
        </ActionButton>
      </SheetCard>
      <SheetCard>
        <CancelButton type="button" onClick={onClose}>
          Cancel
        </CancelButton>
      </SheetCard>
    </BottomActionSheet>
  );
};
